import React from 'react'
import {
  ButtonWrapper,
  CardHead,
  CardTitle,
  ColoredCard,
  TransferOrder,
  TransferOrdersList
} from './styles'
import { CheckpointCardProps } from './types'
import { useTranslation } from 'react-i18n-lite'
import { useIsMobile, Text, Button } from '@yes.technology/react-toolkit'
import TransferOrderCard from 'component/TransferOrderCard'
import SitemodelModal from 'component/SitemodelModal/SitemodelModal'
import { useIsOpen } from 'shared/hooks'
import { useGeolocation } from 'shared/hooks'
import useMapsURL from 'site/Renderer/components/MapContainer/hooks/useMapsURL'

const DOING_CHECKPOINT_STATUSCODE = 4

function CheckpointCard({
  checkpoint,
  status,
  transferOrders
}: CheckpointCardProps) {
  const { currentPosition } = useGeolocation()
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  const { isOpen, open, close } = useIsOpen(false)

  const { uuid_status: statusCode, address } = checkpoint
  const { openMaps } = useMapsURL({
    origin: currentPosition,
    destination: {
      lat: parseFloat(address?.[0]?.latitude || '0'),
      lng: parseFloat(address?.[0]?.longitude || '0')
    }
  })

  const showMapButton = !!address?.[0]?.latitude && !!address?.[0]?.longitude

  const isAbleToView = Number(statusCode) >= DOING_CHECKPOINT_STATUSCODE
  const buttons = (
    <>
      {isAbleToView && (
        <ButtonWrapper>
          <Button onClick={open} variant='secondary'>
            {t('checkpoint-section.view')}
          </Button>
        </ButtonWrapper>
      )}

      {showMapButton && (
        <ButtonWrapper>
          <Button
            onClick={openMaps}
            variant='secondary'
            style={{ marginTop: 8 }}
          >
            {t('checkpoint-section.map-button')}
          </Button>
        </ButtonWrapper>
      )}
    </>
  )

  return (
    <>
      <ColoredCard
        hierarchyCardLevel={2}
        heightClass='extraSmall'
        $backgroundColor={status?.complement as string}
        centerHeaderElement={
          <CardTitle>{`${statusCode} | ${status?.des}`}</CardTitle>
        }
        closedContent={<div className='d-flex flex-column'>{buttons}</div>}
        iconColor='#303032'
      >
        <>
          <Text variant={isMobile ? 'content-04' : 'content-03'}>
            {checkpoint.des}
          </Text>

          {buttons}
        </>

        <TransferOrder spacingClass={isMobile ? 'small' : 'extraSmall'}>
          <CardHead $bgColor='#0056CC'>
            <CardTitle $color='#FFF'>
              {t('checkpoint-section.transfer-order')}
            </CardTitle>
          </CardHead>

          <TransferOrdersList>
            {transferOrders.map((transferOrder) => (
              <TransferOrderCard
                key={transferOrder.uuid}
                transferOrder={transferOrder}
              />
            ))}
          </TransferOrdersList>
        </TransferOrder>
      </ColoredCard>
      {isOpen && (
        <SitemodelModal
          targetSitemodel={globalThis.objectDetailsSitemodelUuid}
          title={`${t('checkpoint-section.view')} | ${checkpoint.des}`}
          searchParams={{
            uuid_objectclass: globalThis.uuidObjectclassCheckpoint,
            'object-uuid': checkpoint.uuid
          }}
          onClose={close}
        />
      )}
    </>
  )
}

export default CheckpointCard
